// Generated by `noded -print-states` (make gen) from internal/states: do not edit.
export interface StateInfo {
    severity: 'info' | 'warning' | 'error'
    tone: 'ok' | 'warn' | 'bad' | 'off'
    rank: number
    seg: string
}

export type StateName =
    | 'running'
    | 'connected'
    | 'ok'
    | 'online'
    | 'connecting'
    | 'starting'
    | 'disabled'
    | 'stopped'
    | 'idle'
    | 'unknown'
    | 'high_load'
    | 'high_temp'
    | 'black'
    | 'low_space'
    | 'not_writable'
    | 'degraded'
    | 'no_input'
    | 'unmounted'
    | 'no_signal'
    | 'no_frames'
    | 'error'
    | 'hardware_fault'
    | 'offline'

export const STATES: Record<StateName, StateInfo> = {
    running: { severity: 'info', tone: 'ok', rank: 0, seg: 'bg-ok' },
    connected: { severity: 'info', tone: 'ok', rank: 0, seg: 'bg-ok' },
    ok: { severity: 'info', tone: 'ok', rank: 0, seg: 'bg-ok' },
    online: { severity: 'info', tone: 'ok', rank: 0, seg: 'bg-ok' },
    connecting: { severity: 'info', tone: 'warn', rank: 1, seg: 'stripe-pending' },
    starting: { severity: 'info', tone: 'warn', rank: 1, seg: 'stripe-pending' },
    disabled: { severity: 'info', tone: 'off', rank: 0, seg: 'stripe-off' },
    stopped: { severity: 'info', tone: 'off', rank: 2, seg: 'stripe-off' },
    idle: { severity: 'info', tone: 'off', rank: 0, seg: 'stripe-off' },
    unknown: { severity: 'info', tone: 'off', rank: 0, seg: 'stripe-none' },
    high_load: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    high_temp: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    black: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    low_space: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    not_writable: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    degraded: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    no_input: { severity: 'warning', tone: 'warn', rank: 3, seg: 'stripe-warn' },
    unmounted: { severity: 'warning', tone: 'bad', rank: 3, seg: 'stripe-bad' },
    no_signal: { severity: 'warning', tone: 'bad', rank: 4, seg: 'stripe-bad' },
    no_frames: { severity: 'warning', tone: 'bad', rank: 4, seg: 'stripe-bad' },
    error: { severity: 'error', tone: 'bad', rank: 4, seg: 'bg-bad' },
    hardware_fault: { severity: 'error', tone: 'bad', rank: 4, seg: 'bg-bad' },
    offline: { severity: 'error', tone: 'bad', rank: 5, seg: 'stripe-bad' },
}
